import React from 'react'
import { Grid, IconButton } from '@material-ui/core/'
import DeleteIcon from '@material-ui/icons/Delete'
import './index.scss'

const CardImgs = ({ img, id, deleteStoryById }) => {
  return (
    <Grid className='wrapperCard'>
      <img src={img} className='cardImg' />
      <Grid className='deleteBox'>
        <IconButton aria-label='delete' onClick={() => deleteStoryById(id)}>
          <DeleteIcon className='deleteIcon' />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default CardImgs
